import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './fontawesome';

// ========== SCSS ==========
import './scss/main.scss';
import './scss/responsive.scss';

window.utils = {
  site_url: 'https://' + window.location.host + '/',
  base_public_path: '/views/area-restrita',
  token: sessionStorage.getItem('token'),
  logged: (sessionStorage.getItem('token') != null)
};

window.doRequest = async function (method, params, siteUrl = null) {
  let url = new URL((siteUrl != null) ? siteUrl : window.utils.site_url);
  let formData = new FormData();

  for (var prop in params) {
    if (params.hasOwnProperty(prop)) {
      formData.append(prop, params[prop]);
      // get url params
      if (method.toLowerCase() == 'get') {
        url.searchParams.append(prop, params[prop]);
      }
    }
  }

  let request = {
    method: method
  };

  if (method.toLowerCase() == 'post')
    request.body = formData;

  let response = await fetch(url.href, request)
  .then(function(response) {
    return response.text();
  })
  .then(function(text) {
    return JSON.parse(text);
  });

  return response;
}

window.normalizeString = function (s) {
  return s.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .split(' ').join('_');
}

window.alph = function ( a, b ) {
  if ( a.name < b.name ) {
    return -1;
  }
  if ( a.name > b.name ) {
    return 1;
  }
  return 0;
}

window.verifyIfIsLogged = function () {
  // redirect if not logged
  if (window.utils.logged != true)
    window.location = '/area-restrita';
}

ReactDOM.render(
  <BrowserRouter basename="/area-restrita">
    <App />
  </BrowserRouter>
, document.getElementById('root'));
